/**
 * Multicolumn PC 左右切换：滚动 .multicolumn-list
 * 在 theme.liquid 或相关 section 中引入：
 * {{ 'section-multicolumn.js' | asset_url | script_tag }}
 */
(function () {
  if (window.__mcSliderNavInit) return;
  window.__mcSliderNavInit = true;

  function getScrollAmount(list) {
    var item = list.querySelector('.multicolumn-list__item, li');
    if (!item) return Math.max(list.clientWidth * 0.8, 300);
    var style = window.getComputedStyle(list);
    var gap = parseFloat(style.columnGap || style.gap) || 20;
    return item.getBoundingClientRect().width + gap;
  }

  function updateButtons(list, prevBtn, nextBtn) {
    var max = list.scrollWidth - list.clientWidth - 2;
    var left = list.scrollLeft;
    if (prevBtn) {
      var atStart = left <= 2;
      prevBtn.disabled = atStart;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    }
    if (nextBtn) {
      var atEnd = left >= max;
      nextBtn.disabled = atEnd;
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }
  }

  function scrollList(list, dir) {
    var amount = getScrollAmount(list);
    list.scrollBy({ left: dir * amount, behavior: 'smooth' });
  }

  function ensureButtons(section) {
    var list = section.querySelector('.multicolumn-list, ul.multicolumn-list');
    if (!list) return null;

    var buttonsWrap = section.querySelector('.slider-buttons');
    var prevBtn = section.querySelector(
      '.slider-button--prev, .slider-button[name="previous"], .slider-button[aria-label*="revious" i], button[name="previous"]'
    );
    var nextBtn = section.querySelector(
      '.slider-button--next, .slider-button[name="next"], .slider-button[aria-label*="ext" i], button[name="next"]'
    );

    // 主题没有箭头时，注入自定义按钮
    if (!prevBtn || !nextBtn) {
      if (!buttonsWrap) {
        buttonsWrap = document.createElement('div');
        buttonsWrap.className = 'slider-buttons mc-slider-buttons';
        section.style.position = section.style.position || 'relative';
        list.parentNode.insertBefore(buttonsWrap, list.nextSibling);
      }

      if (!prevBtn) {
        prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'slider-button slider-button--prev mc-slider-btn';
        prevBtn.setAttribute('aria-label', 'Previous');
        prevBtn.innerHTML =
          '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>';
        buttonsWrap.appendChild(prevBtn);
      }
      if (!nextBtn) {
        nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'slider-button slider-button--next mc-slider-btn';
        nextBtn.setAttribute('aria-label', 'Next');
        nextBtn.innerHTML =
          '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
        buttonsWrap.appendChild(nextBtn);
      }
    }

    return { list: list, prevBtn: prevBtn, nextBtn: nextBtn };
  }

  function wireSection(section) {
    if (section.dataset.mcNavWired === '1') return;
    var parts = ensureButtons(section);
    if (!parts) return;
    section.dataset.mcNavWired = '1';

    var list = parts.list;
    var prevBtn = parts.prevBtn;
    var nextBtn = parts.nextBtn;

    function onPrev(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollList(list, -1);
    }
    function onNext(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollList(list, 1);
    }

    prevBtn.addEventListener('click', onPrev, true);
    nextBtn.addEventListener('click', onNext, true);

    list.addEventListener('scroll', function () {
      updateButtons(list, prevBtn, nextBtn);
    }, { passive: true });

    updateButtons(list, prevBtn, nextBtn);
    window.addEventListener('resize', function () {
      updateButtons(list, prevBtn, nextBtn);
    });
  }

  function init() {
    document.querySelectorAll('.multicolumn').forEach(wireSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.multicolumn').forEach(function (section) {
      section.dataset.mcNavWired = '';
      wireSection(section);
    });
  });
})();
